<template>
  <div class="box">
    <CustomNavBar title="项目招商" />
    <bigCard :data="attrList" />
    <img class="bg-img1" :src="require('@/assets/bg01.png')">
  </div>
</template>

<script>
import CustomNavBar from "@/components/CustomNavBar";
import bigCard from "@/components/CustomCard/bigCard.vue";

import { mapGetters } from "vuex";
export default {
  name: "LIST",
  components: {
    CustomNavBar,
    bigCard,
  },
  computed: {
    ...mapGetters(["attrList"]),
  },
  mounted() {
    this.$store.commit('set_istab', true)
  },
};
</script>

<style lang="scss" scoped>
.box {
  height: 100%;
  background: #f5f7fa;
  position: relative;

  .bg-img1{
      position: absolute;
      left: 0;
      bottom: 50px;
      width: 200px;
      height: auto;
    }
}
</style>
